<!-- 养护计划登记 -->
<template>
   <div>
      <el-drawer :close-on-press-escape="true" title="基础信息" :visible.sync="dataActionBox.showStatus" :with-header="false" :append-to-body="true" custom-class="drawer_box" :direction="dataActionBox.openMode" size="100%">
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="(val) => { mxHeight = val }">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <!-- 主要信息 -->
                        <div v-if="scope.index == 0">
                           <el-form label-width="120px" id="mainInfo" :model="sendDataInfo" ref="sendDataInfo" size="mini">
                              <el-row>
                                 <el-form-item :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey" v-if="formOneValue.isShow == 1"
                                               :prop="formOneValue.entityField">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                    <el-select v-if="formOneValue.entityField == 'cpmType'" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择" disabled>
                                       <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.value" :value="item.key"></el-option>
                                    </el-select>
                                    <el-date-picker v-else-if="formOneValue.entityField == 'cpmStdate'" v-model="sendDataInfo[formOneValue.entityField]" type="date" disabled placeholder="选择日期" format="yyyy 年 MM 月 dd 日"
                                                    value-format="timestamp">
                                    </el-date-picker>
                                    <el-date-picker v-else-if="formOneValue.entityField == 'conservationDate'" v-model="sendDataInfo[formOneValue.entityField]" type="date" :disabled="formOneValue.isChange == 0"
                                                    placeholder="选择日期" format="yyyy 年 MM 月 dd 日" value-format="timestamp">
                                    </el-date-picker>
                                    <el-input v-else v-model="sendDataInfo[formOneValue.entityField]" disabled>
                                    </el-input>
                                 </el-form-item>
                              </el-row>
                           </el-form>

                           <!-- 明细 -->
                           <el-form :inline="true" size="mini">
                              <div style="margin-bottom: .2rem;">
                              </div>
                              <el-table id="mxTable" :data="sendDataInfo.curingplandetailList" border style="width: 100%" :height="mxHeight" size="mini">
                                 <el-table-column align="center" v-if="formOneValue.isShow == 1" min-width="180" :prop="formOneValue.entityField" :label="formOneValue.showField"
                                                  v-for="(formOneValue, formOneKey) in mxForm" :key="formOneKey">
                                    <template slot-scope="scope">
                                       <!-- 系统字段 -->
                                       <el-input v-if="formOneValue.entityField == 'cpdNumber'" :min="0" type="number"
                                                 v-model.number="sendDataInfo.curingplandetailList[scope.$index][formOneValue.entityField]"></el-input>
                                       <el-input v-else-if="formOneValue.entityField == 'cpdReason'" v-model.number="sendDataInfo.curingplandetailList[scope.$index][formOneValue.entityField]"></el-input>
                                       <el-date-picker v-else-if="formOneValue.entityField == 'cpdCdate'" v-model="sendDataInfo.curingplandetailList[scope.$index][formOneValue.entityField]" type="date" placeholder="选择日期"
                                                       format="yyyy 年 MM 月 dd 日" value-format="timestamp">
                                       </el-date-picker>
                                       <el-input v-else-if="formOneValue.entityField == 'cpdCperson'" @focus="openSearch(formOneValue.searchId, scope.$index, 'cpdCperson')"
                                                 v-model="sendDataInfo.curingplandetailList[scope.$index].opmName">
                                       </el-input>
                                       <el-select v-else-if="formOneValue.entityField == 'cpdMeasures'" multiple collapse-tags v-model="sendDataInfo.curingplandetailList[scope.$index][formOneValue.entityField]"
                                                  placeholder="请选择">
                                          <el-option v-for="item in dictionariesData" :key="item.diValue" :label="item.diValue" :value="item.diValue"></el-option>
                                       </el-select>
                                       <div v-else-if="formOneValue.fieldType == 'formatter'">
                                          <el-select v-model="sendDataInfo.curingplandetailList[scope.$index][formOneValue.entityField]" placeholder="请选择">
                                             <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.value" :value="item.key"></el-option>
                                          </el-select>
                                       </div>
                                       <span v-else-if="formOneValue.isRift == 1">
                                          <a @click="toDetail(sendDataInfo.curingplandetailList[scope.$index][formOneValue.riftField])">{{
                                                                sendDataInfo.curingplandetailList[scope.$index][formOneValue.entityField]
                                                            }}</a>
                                       </span>
                                       <el-input v-else-if="formOneValue.entityField == 'cpdConclusion'" v-model="sendDataInfo.curingplandetailList[scope.$index][formOneValue.entityField]"></el-input>
                                       <el-input v-else-if="formOneValue.entityField == 'gcdCremark'" v-model="sendDataInfo.curingplandetailList[scope.$index][formOneValue.entityField]"></el-input>
                                       <span v-else-if="formOneValue.fieldType == 'date'">
                                          <span> {{ $common.getLocalTime(scope.row[formOneValue.entityField])
                                                        }}</span>
                                       </span>
                                       <span v-else>
                                          {{
                                                            sendDataInfo.curingplandetailList[scope.$index][formOneValue.entityField]
                                                        }}</span>
                                    </template>
                                 </el-table-column>

                              </el-table>
                           </el-form>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>
            <!-- 页脚 -->
            <div class="foot">
               <div style="text-align: center;">
                  <el-button type="primary" @click="initActionBox('sendDataInfo')">取消</el-button>
                  <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 1">完成养护</el-button>
               </div>
               <div style="text-align: center;" v-if="formDataList[2]">
                  <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline">
                     <el-form-item :label="itemV.chineseField" v-for="(itemV, itemK) in footForm" :key="itemK">
                        <el-button type="success">{{ sendDataInfo[itemV.entityField] }}</el-button>
                     </el-form-item>
                  </el-form>
               </div>
            </div>
         </div>

      </el-drawer>
      <!-- 检索方案弹窗 -->
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
   name: "maintenanceregisteActine",
   props: [],
   //import引入的组件需要注入到对象中才能使用
   components: { SearchScheme },
   data() {
      //这里存放数据
      return {
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         sendDataInfo: {
            conservationDate: "",
            lomAppreason: "",
            lomApptype: 0,
            lomReserves1: "",
            lomReserves2: "",
            lomReserves3: "",
            lomReserves4: "",
            lomReserves5: "",
            lomReserves6: "",
            lomId: "",
            curingplandetailList: [
               {
                  opmName: "",
               },
            ],
            totalMoney: 0,
            totalNumber: 0,
            totalCount: 0,
         },
         detaislDataInfo: {},
         selectGoodsInfo: "",
         showTabs: "",
         formDataList: [],
         tabForm: [],
         mxForm: [],
         footForm: [],
         seTitle: "", //检索
         DialogVisible: false,
         seWidth: "0",
         seId: 0,
         selectedDetailsIndex: 0, //选择索引
         focusIndex: 0, //检索焦点索引
         seType: "",
         dictionariesData: [],
         mxHeight: 400
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {},
   //方法集合
   methods: {
      // 子组件穿透方法
      toDetail(orderId) {
         this.$parent.toDetail(orderId);
      },
      // 获取字典数据
      async getPartDictionariesData() {
         let responseData = await this.$http.getPartDictionariesData({
            ids: [19],
         });
         if (responseData.status == 200) {
            this.dictionariesData = responseData.result.yhcs;
            console.log(this.dictionariesData);
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type) {
         this.focusIndex = index;
         this.DialogVisible = true;
         this.seId = sId;
         this.seType = type;
         console.log(type, "tyet");
      },
      //检索带回数据
      changeInputModel(val) {
         console.log("返hui", val);
         if (val != "" || val != undefined) {
            this.DialogVisible = false; //关闭商品检索窗口

            if (this.seType == "cpdCperson") {
               console.log(
                  this.sendDataInfo.curingplandetailList[this.focusIndex].opmName,
                  "opmName"
               );
               this.sendDataInfo.curingplandetailList[this.focusIndex].opmName =
                  val.opmName;
            }
            //赋值给当前行
            if (val.bgmId)
               for (const key in val) {
                  if (Object.hasOwnProperty.call(val, key)) {
                     this.$set(
                        this.sendDataInfo.curingplandetailList[this.focusIndex],
                        key,
                        val[key]
                     );
                  }
               }
         } else {
            this.DialogVisible = false;
            this.$message({
               message: "检索失败",
               type: "error",
            });
         }
         console.log("检索返后", this.sendDataInfo);
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },

      // 确认新增
      async sendDataAction(formName) {
         let flag = false;
         this.$refs[formName].validate((valid) => {
            if (valid) {
            } else {
               return false;
            }
         });
         if (flag) return false;
         // console.log(this.sendDataInfo, "a");
         let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
         sendData.curingplandetailList.forEach((item, index) => {
            let a = item.cpdMeasures.join();
            sendData.curingplandetailList[index].cpdMeasures = a;
         });
         if (this.dataActionBox.actionType == 0) {
            var responseData = await this.$http.addMaintenancePlanList(sendData);
         } else {
            var responseData = await this.$http.submitMaintenancePlan(sendData);
         }
         if (responseData.status == 200) {
            this.dataActionBox.showStatus = false;
            this.init();
            this.$message({
               message: "操作成功",
               type: "success",
            });

            this.$parent.getDataList();
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      //取消新增
      initActionBox(formName) {
         this.$confirm("确定取消新增吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.dataActionBox.showStatus = false;
               this.init();
            })
            .catch(() => { });
      },

      async isShowData(name, value) {
         this.sendDataInfo[name] = value;
      },
      //新增明细
      addDetails() {
         this.sendDataInfo.curingplandetailList.push({
            batchno: "", //批号
            rowno: "", //行号
            bgmId: 0,
            bgsId: 0,
            expidate: 0, // 有效期
            lotno: "", //行号
            money: 0, // 金额
            lodNumber: 0, // 报损数量
            lodReserves1: "", //预留字段
            lodReserves2: "",
            lodReserves3: "",
            lodReserves4: "",
            lodReserves5: "",
            lodReserves6: "",
            price: 0, // 单价
            prodate: 0, // 生产日期
            psmoney: 0, // 含税金额
            psprice: 0, // 含税价格
         });
      },
      //删除明细
      deleteDetails() {
         if (this.sendDataInfo.curingplandetailList.length < 1) {
            this.$message({
               message: "请先添加明细",
               type: "error",
            });
            return false;
         }
         this.sendDataInfo.curingplandetailList.splice(
            this.selectedDetailsIndex,
            1
         );
         this.selectedDetailsIndex = 0;
      },
      // 初始化
      init() {
         this.sendDataInfo.curingplandetailList = [];
         this.sendDataInfo.lomApptype = 0;
         this.dataActionBox.actionType = 0;
      },
      //父级传入
      openBox(cate, formData, oldData = "") {
         console.log(cate, oldData);
         console.log(cate, formData, "formData");
         //   oldData = JSON.parse(JSON.stringify(oldData)); //防干扰
         this.showTabs = formData[0].jciName;
         this.formDataList = formData;
         this.filterMainField();
         this.init();
         if (cate == 0) {
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
         } else {
            this.dataActionBox.boxTitle = "编辑信息";
            this.dataActionBox.openMode = "ltr";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key])
            }
         }
         if (oldData.conservationDate == '' || oldData.conservationDate == null || oldData.conservationDate == undefined) {
            this.sendDataInfo.conservationDate = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1
         }

         this.$nextTick(() => {
            setTimeout(() => {
               if (this.dataActionBox.actionType != 2) {
                  this.mxHeight = this.$common.getBtnHeight()
               } else {
                  this.mxHeight = this.$common.getHeight()
               }
            }, 16.7)
         });
         this.dataActionBox.actionType = cate;
         this.dataActionBox.showStatus = true;
      },
      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = [];
         this.formDataList.forEach((item) => {
            if (item.jciType == 1) {
               mainFormList.push(item);
            } else if (item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
               this.mxForm.forEach(item1 => {
                  if (item1.fieldType == 'number') {
                     this.$set(this.detaislDataInfo, item1.entityField, 0)
                  } else if (item1.fieldType == 'search' && item1.setField) {
                     var arr = item1.setField.split(',')
                     arr.forEach(item2 => {
                        this.$set(this.detaislDataInfo, item2, "")
                     })
                  } else {
                     this.$set(this.detaislDataInfo, item1.entityField, "")
                  }
               })
            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
            }
         });
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key));
            this.tabForm[i].jurconfigform = [];
            for (let index = 0; index < key.jurconfigform.length; index++) {
               if (key.jurconfigform[index].isShow == 1)
                  this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
            }
         });
         var arr = [{ entityField: "curingplandetailList" }]
         var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key])
         }
         this.$set(this.sendDataInfo, "lomApptype", 0)
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.getPartDictionariesData();
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {
   },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
   width: 100%;
}

.el-drawer {
   outline: none;
}

/* 表格样式更改*/
#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
   margin-bottom: 0;
}

::v-deep .el-form-item__content {
   width: 200px;
}
</style>